<template>
    <div class="special-wrap">
        <img class="top-img" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/household/spacil_v3.png" />
        <img class="btn-img" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/household/btn-img-v2.png" @click="showMask" />
        <div class="case-content">
             <div class="case-content" v-infinite-scroll="loadMore">
                <div class="case-item" v-for="item in arrCeoCase" :key="item.id">
                    <img class="b-bgc" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/bgc-c.png" />
                    <div class="content">
                        <div class="title-wrap">
                            <div class="title_xian">
                                <div class="title">{{item.title}}</div>
                            </div>
                            <div class="icon-pes">    
                                <img mode="widthFix" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/icon-peslV3.png" />
                                <div class="look" @click="lookMore(item.id)">查看全文</div>
                            </div>
                        </div>
                        <div class="pic-content">
                            <div class="pic-item" v-for="(imgItem,imgIndex) in item.image_path" :key="imgIndex" v-if="imgIndex<2">
                                <img :src="imgItem" mode="widthFix" />
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <div class="name-address">
                            <div class="name">{{item.nickname}}</div>
                            <div class="address">{{item.province_name}}-{{item.city_name}}</div>
                        </div>
                        <div class="shop">
                            <div class="type">{{goodsType(item.goods_type)}}</div>
                            <div class="icon-wrap">
                                <div class="views-icon">
                                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/earth-icon.png" />
                                    <span class="num">{{item.check_count?item.check_count:0}}</span>
                                </div>
                                <div class="views-icon">
                                    <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/start-icon.png" />
                                    <span class="num">{{item.collect_num?item.collect_num:0}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <!-- 如何写信弹框 -->
        <div class="write-letters" v-if="isShowMask">
            <div class="write-warp">
                <div class="write-content">
                    <img mode="widthFix" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/emr_zc_v2.png" class="write-img" />
                </div>
                <div class="close">
                    <img @click="closeMask" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/close_icon@2x.png" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {requestAesPost5} from '@/libsV2/requestAes.js'
import { Toast } from 'vant'
export default {
    created(){
        this.getList()
    },
    data(){
        return{
            isShowMask:false,//如何写信弹框
            nPage:0,
            arrCeoCase:[]
        }
    },
    methods:{
        loadMore(){
            this.nPage++;
            this.getList()
        },
        goodsType (value) {
            let arrType = value.split(",").join(" · ");
            return '· ' + arrType
        },
        getList(){
            this.$store.commit("loadSwitch", true);
            requestAesPost5('topic/subjectaes/index',{page:this.nPage,limit:10,type:1}).then(res=>{
                this.$store.commit("loadSwitch", false);
                console.log(res.data.data.result.list,'列表')
                if (res.data.error == 0) {
                        let arr = this.arrCeoCase.concat(res.data.data.result.list);
                        this.arrCeoCase=arr
                }
            })
        },
        showMask(){
            this.isShowMask=true
        },
        closeMask(){
              this.isShowMask=false
        },
        lookMore(id){
            this.nPage=0
            this.$router.push({path:"/case/map/v2/specialinfo",query:{id:id}})
        },
    }
}
</script>

<style lang="scss" scoped>
    @import './special.scss'
</style>